import { render, staticRenderFns } from "./FiltersSidebarSection.vue?vue&type=template&id=f06e9628&"
import script from "./FiltersSidebarSection.vue?vue&type=script&lang=js&"
export * from "./FiltersSidebarSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports